export class Setor {
  constructor({
    id = null,
    nome = null,
    origem = null,
    funcoes = null,
  }) {
    this.id = id;
    this.nome = nome;
    this.origem = origem;
    this.funcoes = funcoes;
  }
  static Build() {
    return new Setor({
      id: null,
      nome: null,
      origem: null,
      funcoes: null,
    });
  }
  format() {
    const funcoes = this.funcoes.map(f => f.id);
    const origem = this.origem.id;
    return new Setor({...this, origem, funcoes});
  }
}
